<template>
  <div class="blog">
    <div class="blog-header"></div>
    <div class="blog-container">
      <div v-for="post in posts" :key="post.id" class="blog-post">
        <Post :post="post" :card="true" />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.blog {
  margin-top: 20px;
  padding-top: 100px;
  padding-bottom: 100px;
  background-color: #34515e; //#cecece;
  color: white;
  background-image: url("~@/assets/blog-bg-4.jpg");
  /* Create the parallax scrolling effect */
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.blog-container {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-content: stretch;
}
.blog-post {
  margin-top: 10px;
  margin-bottom: 80px;
}
.blog-header {
  display: none;
}
@media only screen and (max-width: 768px) {
  .blog-header {
    display: block;
    background-image: url("~@/assets/blog-bg-4.jpg");
    background-size: cover;
    background-repeat: no-repeat;
    padding-top: 300px;
  }
  .blog {
    padding-top: 0px;
    background-image: none;
  }
}
</style>

<script>
import Post from "./Post.vue";

export default {
  name: "Blog",
  components: {
    Post
  },
  data() {
    return {
      posts: []
    };
  },
  mounted() {
    this.$parent.$analytics.setCurrentScreen("blog");
    this.$parent.$analytics.logEvent("page_view");
    fetch("https://nateintolubbe.appspot.com/wp-json/wp/v2/posts")
      .then(r => r.json())
      .then(res => (this.posts = res));
  }
};
</script>
